export const data=[
    {
        imgSrc:require('../../../assets/candleStick.png'),
        code:`import { CandleStickChart } from "react-native-gifted-charts";
        
const App = () => {
    
  const data = [
    { open: 50, high: 75, low: 45, close: 72 },
    { open: 72, high: 78, low: 38, close: 42 },
    { open: 42, high: 65, low: 35, close: 60 },
    { open: 60, high: 95, low: 58, close: 89 },
    { open: 75, high: 80, low: 20, close: 25 },
    { open: 25, high: 55, low: 22, close: 52 },
    { open: 52, high: 85, low: 48, close: 82 },
    { open: 82, high: 86, low: 30, close: 35 },
    { open: 35, high: 60, low: 32, close: 58 },
  ];

  return <CandleStickChart data={data} />;

};`
    },
]